import { createFileRoute } from "@tanstack/react-router";

import { DocumentView } from "@/features/research/modules/document-view/document-view";
import { m } from "@/paraglide/messages.js";

export const Route = createFileRoute("/(private)/library/$documentId/")({
  component: RouteComponent,
  loader: () => ({ crumb: m.research_document_crumb() }),
});

function RouteComponent() {
  const { documentId } = Route.useParams();
  // Keyed so that moving between documents resets the viewer and the tabs.
  return <DocumentView key={documentId} documentId={documentId} />;
}
